import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import SurgeStudents from "./components/pages/SurgeStudents";
import PaduSpoke from "./components/pages/PaduSpoke";
import SurgeSpeakers from "./components/pages/SurgeSpeakers";
import SurgeStudentsForm from "./components/pages/Forms/SurgeStudentsForm";
import { ToastContainer } from "react-toastify";
import SurgeSpeakerForm from "./components/pages/Forms/SurgeSpeakersForm";
import SurgeCollegeForm from "./components/pages/Forms/SurgeCollegeForm";
import About from "./components/pages/terms/about";
import ContactUs from "./components/pages/terms/contact";
import Privacy from "./components/pages/terms/privacy";
import Conditions from "./components/pages/terms/conditions";
import Refund from "./components/pages/terms/refund";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SurgeStudents />} />
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route path="/surge-colleges" element={<PaduSpoke />} />
        <Route path="/surge-speakers" element={<SurgeSpeakers />} />
        <Route path="/surge-students/form" element={<SurgeStudentsForm />} />
        <Route path="/surge-speakers/form" element={<SurgeSpeakerForm />} />
        <Route path="/surge-colleges/form" element={<SurgeCollegeForm />} />
        <Route path="/about" element={<About />} />
        <Route path="/terms-and-conditions" element={<Conditions />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="dark"
      />
    </Router>
  );
}